import { render } from "./SideBar.vue?vue&type=template&id=0d0fd7ae&ts=true"
import script from "./SideBar.vue?vue&type=script&lang=ts"
export * from "./SideBar.vue?vue&type=script&lang=ts"

import "./SideBar.vue?vue&type=style&index=0&id=0d0fd7ae&lang=scss"

import exportComponent from "/Users/lxb/kuaike/kunpeng-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__